import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { Modal } from "@/shared/ui/modal"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"
import { useForm } from "react-hook-form"
import {
    closeConfirmBlockModal,
    fetchBlockUser,
    selectBlockAction,
    selectCurrentUser,
    selectIsConfirmBlockModalOpen,
    selectOnSuccess
} from "../../model"
import { getDisplayName } from "@/entities/user"

export const ConfirmBlockModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectIsConfirmBlockModalOpen)
    const currentUser = useAppSelector(selectCurrentUser)
    const action = useAppSelector(selectBlockAction)
    const onSuccess = useAppSelector(selectOnSuccess)

    const handleClose = () => {
        dispatch(closeConfirmBlockModal())
    }

    const onSubmit = async () => {
        await new Promise<void>((res, rej) => {
            dispatch(fetchBlockUser())
                .unwrap()
                .then(() => {
                    notify.success(action === 'block' ? 'Пользователь заблокирован' : 'Пользователь разблокирован')
                    onSuccess?.()
                    handleClose()
                    res()
                })
                .catch((e) => {
                    notify.error(getErrorMessage(e))
                    rej()
                })
        })
    }

    const { handleSubmit, formState: { isSubmitting } } = useForm()

    const userLabel = currentUser ? getDisplayName(currentUser) : ''

    const title = action === 'block' ? 'Блокировка пользователя' : 'Разблокировка пользователя'
    const confirmText = action === 'block' ? 'Заблокировать' : 'Разблокировать'
    const message =
        action === 'block'
            ? `Вы уверены, что хотите заблокировать пользователя ${userLabel}?`
            : `Вы уверены, что хотите разблокировать пользователя ${userLabel}?`

    return (
        <Modal isOpen={isOpen} title={title} onRequestClose={handleClose}>
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
                <div>{message}</div>
                <div className="w-full flex gap-3">
                    <button type="button" onClick={handleClose} className="form_cancel_button">
                        Отменить
                    </button>
                    <button disabled={isSubmitting} className="form_handle_button" type="submit">
                        {confirmText}
                    </button>
                </div>
            </form>
        </Modal>
    )
}
